import * as yup from 'yup';
import { TranslateFn } from '../../../library/validationRules';
import ResourcesIds from '../../../resources/ResourcesIds';

/** What the patient's booking wizard holds while it is being answered. */
export interface AppointmentBookingFormValues {
    /** Tagged so one pick can name a plan or a catalogue line: 'plan:<id>' | 'service:<id>'. */
    choice: string;
    /** Empty until a service has named which therapists can be asked. */
    therapistId: string;
    /**
     * The chosen slot's start.
     *
     * There is no separate `day`: the slot picker owns which day is being looked at, and
     * this value already names it in its first ten characters. A second field would have
     * been one the form could never disagree with and never usefully validate.
     */
    slotStartsAt: string;
}

/**
 * Every field is a picker, and each one only appears once the one before it is answered --
 * so in practice these rules gate the Book button rather than ever printing a message.
 * They are written down anyway: the button's condition is then the schema's, like every
 * other form, instead of a hand-kept boolean that drifts from it.
 */
export const createAppointmentBookingSchema = (translate: TranslateFn) => yup.object({
    choice: yup.string().required(translate(ResourcesIds.BOOK_APPOINTMENT_SERVICE_REQUIRED)),
    therapistId: yup.string()
        .required(translate(ResourcesIds.BOOK_APPOINTMENT_THERAPIST_REQUIRED)),
    slotStartsAt: yup.string().required(translate(ResourcesIds.BOOK_APPOINTMENT_SLOT_REQUIRED)),
});
